import { openMovieMeApp } from '../../lib/openMovieMeApp';

type Props = {
  openAppLabel?: string;
  secondaryLabel?: string;
  onSecondary?: () => void;
  supportingCopy?: string;
};

/**
 * Post-success actions for browser auth email flows.
 * Primary opens the native app; secondary continues on the website.
 * Never auto-fires — user must tap.
 */
export function AuthReturnActions({
  openAppLabel = 'Open MovieMe app',
  secondaryLabel = 'Sign in on the website',
  onSecondary,
  supportingCopy = 'You can also close this tab and open MovieMe yourself.',
}: Props) {
  return (
    <div className="space-y-3">
      <button
        type="button"
        onClick={openMovieMeApp}
        className="btn-marquee min-h-[44px] w-full px-4 py-3"
      >
        {openAppLabel}
      </button>
      {onSecondary ? (
        <button
          type="button"
          onClick={onSecondary}
          className="btn-ghost min-h-[44px] w-full px-4 py-3"
        >
          {secondaryLabel}
        </button>
      ) : null}
      <p className="pt-1 text-center text-xs leading-relaxed text-muted-foreground/80">
        {supportingCopy}
      </p>
    </div>
  );
}
